import { displayGameName } from '../../../shared/game-display-name.mjs'

const templateLabels = { saiche: '赛车', fantan: '番摊', pjx: '十门', paijiu: '五门', shishi: '时时彩', kuaisan: '快三', klsf: '快乐十分', liuhe: '六合彩' }

export function gameTypeLabel(game) {
  return displayGameName(game?.game_type || templateLabels[game?.game_template] || '')
}

export function gameChoiceLabel(game) {
  const name = game?.game_title || game?.game_name || ''
  const type = gameTypeLabel(game)
  return name && type ? `${name} · ${type}` : name || type
}
